import { useState } from 'react';
import { uploadImagemLiga, uploadBannerLiga, atualizarImagemLiga, atualizarBannerLiga } from '../services/ligaService';
import type { Liga } from '../types/liga';

interface UseLigaImageUploadReturn {
  uploadImagem: (ligaId: string, file: File) => Promise<Liga>;
  uploadBanner: (ligaId: string, file: File) => Promise<Liga>;
  loading: boolean;
  error: string | null;
}

export const useLigaImageUpload = (): UseLigaImageUploadReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadImagem = async (ligaId: string, file: File): Promise<Liga> => {
    setLoading(true);
    setError(null);
    
    try {
      // Upload file and get URL
      const imageUrl = await uploadImagemLiga(ligaId, file);
      
      // Update liga with new image URL
      const updatedLiga = await atualizarImagemLiga(ligaId, imageUrl);
      
      return updatedLiga;
    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao fazer upload da imagem.';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const uploadBanner = async (ligaId: string, file: File): Promise<Liga> => {
    setLoading(true);
    setError(null);
    
    try {
      // Upload file and get URL
      const bannerUrl = await uploadBannerLiga(ligaId, file);
      
      // Update liga with new banner URL
      const updatedLiga = await atualizarBannerLiga(ligaId, bannerUrl);
      
      return updatedLiga;
    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao fazer upload do banner.';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    uploadImagem,
    uploadBanner,
    loading,
    error,
  };
};